import { IconProps } from './icon';

export function IconBigArrowLeft({
  size = '100%',
  fill = 'currentColor',
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="-0.2 0 19 25"
      fill="none"
    >
      <path
        d="M0.584725 13.0457C0.261659 12.7226 0.26166 12.1988 0.584725 11.8757L11.8748 0.585669C12.1979 0.262603 12.7217 0.262604 13.0447 0.585669L18.1041 5.64505C18.4272 5.96812 18.4272 6.49191 18.1041 6.81498L13.044 11.875C12.721 12.1981 12.721 12.7219 13.044 13.045L18.1055 18.1064C18.4285 18.4295 18.4285 18.9533 18.1055 19.2764L13.0454 24.3364C12.7223 24.6595 12.1986 24.6595 11.8755 24.3364L0.584725 13.0457Z"
        fill={fill}
      />
    </svg>
  );
}
